export { default } from './square-icon'
export type { Props as SquareIconProps } from './square-icon'
